const admx = {
  "admx.login_email_placeholder": "admin@esteva.ch",
  "admx.team_languages_placeholder": "DE, EN, IT, SQ",
};

export default admx;
